var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[_vm.spacing]},[_c('z-icon',{staticClass:"mb-px inline flex-shrink-0",attrs:{"icon":_vm.icon,"size":_vm.size,"color":_vm.iconColor}}),_vm._v(" "),_c('span',{class:[_vm.textColor, _vm.textSize, _vm.wordBreak, 'inline']},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.label))]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }